import {
	Link as RemixLink,
	type LinkProps as RemixLinkProps,
} from '@remix-run/react'
import { cva } from 'class-variance-authority'

const linkVariants = cva('cursor-pointer', {
	variants: {
		variant: {
			'purple-400': `
     text-purple-400

     hover:text-purple-200
   `,
			white: `
     text-white

     hover:text-primary
   `,
			black: `
     text-foreground

     hover:font-semibold
   `,
			primary: `
     text-primary-600

     hover:text-primary
   `,
		},
	},
})

interface LinkProps extends Omit<RemixLinkProps, 'to'> {
	variant?: 'white' | 'black' | 'primary' | 'purple-400' // Define variant types
	onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void
	to?: RemixLinkProps['to']
}

function Link({ variant, className, to, ...props }: LinkProps) {
	return to ? (
		<RemixLink
			to={to}
			className={linkVariants({ variant, className })}
			{...props}
		/>
	) : (
		<span className={linkVariants({ variant, className })} {...props} />
	)
}

export default Link
